module.exports = __webpack_public_path__ + "img/cooperator.9b021ed4.png";